<template>
    <div v-show="!props.hide" :class="order ? 'picked-order' : ''">
        <sp-form
            class="mobile-general-form-order"
            :class="`uuid-${config.uuid} ${globalModel.preview ? 'preview-text' : ''} ${notChanged ? 'disable-opacity' : ''}`"
            ref="elForm"
            :model="formModel"
            :rules="rules"
        >
            <sp-form-item prop="pickerValue">
                <sharp-comp-select
                    :label="i18nLabel"
                    :is-required="props.required && !globalModel.preview"
                    :readonly="globalModel.preview || globalModel.hideSubmitStyle"
                    @click="onClick"
                    :placeholder="dealPlaceHolder"
                ></sharp-comp-select>
                <div class="sp-form-item__error">
                    {{ errorMsg }}
                </div>
            </sp-form-item>
        </sp-form>
        <order-item class="order-item" v-if="order" :order="order"></order-item>
        <picker-panel v-model="panelShow" title="选择订单">
            <order-list
                v-if="panelShow"
                @picked="onPick"
                :isPageParams="props.isPageParams"
                :api="api"
            ></order-list>
        </picker-panel>
        <sub-title class="plr19 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
    </div>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import SharpCompSelect from '@ks/sharp-comp-form-select';
import '@ks/sharp-comp-form-select/lib/themes/default/index.css';
import isEqual from 'lodash/isEqual';
import ComponentBase from '../component-base';
import { component } from './props';
import PickerPanel from './picker-panel';
import OrderList from './order-list';
import OrderItem from './order-item';
import { fetchOrderDetail, getDealwithOrder } from './order-util';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';
import SubTitle from '../component-base/common/sub-title';
import { toast } from '../../utils';

const mapOrderTypeName = 'Map__OrderType';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SharpCompSelect,
        PickerPanel,
        OrderList,
        OrderItem,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                oid: '',
            },
            panelShow: false,
            order: null,
            orderType: '',
            isPaidContentOrder: false,
            errorMsg: '',
        };
    },
    computed: {
        rules() {
            return {
                oid: this.composeRules(this.props),
            };
        },
        placeholder() {
            if (this.globalModel.noticeFormPreview && !this.order) {
                return this.formModel.oid;
            }
            return this.formModel.oid ? this.props.seletedPlaceholder : this.props.placeholder;
        },
        api() {
            return this.props.apiUrl || '';
        },
        dealPlaceHolder() {
            if (this.globalModel.noticeFormPreview && !this.order) {
                return this.formModel.oid;
            }
            return !this.globalModel.preview && !this.globalModel.hideSubmitStyle ? this.i18n(this.placeholder) : '';
        },
    },
    watch: {
        'formModel.oid': {
            immediate: true,
            handler(oid) {
                const params = new URLSearchParams(location.search);
                const urlOid = params.get('oid');
                // console.log('formModel.oid', oid, this.order);
                if (oid && !urlOid && !this.order) {
                    // 外部传入的globalFormData有效
                    this.getOrder();
                }
            },
        },
        panelShow(val) {
            formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, val);
        },
    },
    methods: {
        async getOrder() {
            const orderType = this.getFormDataValueByPath(`${mapOrderTypeName}.${this.outputPath}`);
            const { data } = await fetchOrderDetail({
                oid: this.formModel.oid,
                orderType: orderType || this.orderType,
            });
            this.order = getDealwithOrder(data);
        },
        async onClick() {
            if (!this.onClickForm()) {return;}
            this.panelShow = true;
        },
        onPick(order) {
            this.order = order;
            this.formModel.oid = order.oid;
            this.onPickerValueChange();
            this.$emit('user-input');
            this.panelShow = false;
        },
        onPickerValueChange() {
            this.order && this.setFormDataValueByPath(this.order.orderType || '', `${mapOrderTypeName}.${this.outputPath}`);
            const res = this.setSelfFormDataValue(this.formModel.oid);
            if (!this.formModel.oid) {
                this.order = null;
            }
            if (res) {
                // 数据修改成功，抛出change 事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                this.formModel.oid = '';
                this.onPickerValueChange('');
                // this.validate();
                return;
            }

            if (!isEqual(this.formModel.oid, newValue)) {
                this.formModel.oid = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            if (!this.formModel.oid && this.props.required) {
                const errorMsg = this.i18n(this.props.errRequired, this.i18nLabel) || `${this.i18nLabel}不能为空`;
                this.errorMsg = errorMsg;
                this.validateFailureHandler(errorMsg);
                return false;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                this.errorMsg = '';
                return await promise;
            } catch (e) {
                this.errorMsg = e.pickerValue[0].message;
                this.validateFailureHandler(e.pickerValue[0].message);
                return false;
            }
        },
        clearValidate() {
            this.errorMsg = '';
            this.$refs.elForm && this.$refs.elForm.clearValidate();
        },
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(async () => {
                const params = new URLSearchParams(location.search);
                const oid = params.get('oid');
                const orderType = params.get('orderType');
                if (oid) {
                    // this.$set(this.formModel, 'oid', oid);
                    this.orderType = orderType;
                    if (orderType === '9') {
                        this.api = '/rest/csc/center/order/paid/content/list';
                        this.isPaidContentOrder = true;
                    }
                    const { data } = await fetchOrderDetail({
                        oid,
                        orderType,
                    });
                    const order = getDealwithOrder(data);
                    this.onPick(order);
                }
            }, 2000);

        });
    },
};
</script>

<style lang="less" scoped>
@import '../../style.less';
.picked-order {
    padding-bottom: 20px;
    & /deep/ .spc-formable {
        border-bottom: 0 !important;
    }
}
</style>
